import * as React from "react";
import "./skeletonImage.css";
import { generateImgSrc } from "src/share/utils/generateImgSrc";


interface ISkeletonImageProps {
  index?: string | number
  height?: number
  width?: number;
}
const getRandomHeight = () => {
  const max = 300;
  const min = 150;
  return Math.round(Math.random() * (max - min) + min);
};


export const SkeletonImage = (props: ISkeletonImageProps) => (
  <img
    className="skeleton-image"
    src={generateImgSrc(props.width || getRandomHeight(), props.height || getRandomHeight())}
    key={`Skeleton-${props.index}`} />
);